import { PresenceResource, presenceResource } from '@/resources/presence.resource';

import { PresenceFeeFunctions } from '@/enums/presenceFeeFunctions.enum';
import { TableName } from '@/enums/tableName.enum';
import { ListResponse } from '@/interfaces/list';
import { Presence } from '@/interfaces/presence';
import { EntityModule } from '../entity.module';

/**
 * Moduł list obecności składek
 *
 * @export
 * @class PresencesModule
 * @extends { EntityModule<Presence, PresenceResource> }
 */
export class FeePresencesModule extends EntityModule<Presence, PresenceResource> {
  constructor() {
    super(presenceResource);

    this.state = {
      ...this.state,
      entityType: undefined
    };
    this.actions = {
      ...this.actions,
      list: (context: any, filters: any): Promise<void> => {
        if (context.state.filters) {
          filters = { ...context.state.filters, ...filters };
        }
        const presenceFunction = (PresenceFeeFunctions as any)[context.state.entityType];
        return (this.resource as any)[presenceFunction](filters).then(({ list, count }: ListResponse<Presence>) => {
          context.commit('saveList', list);
          context.commit('saveCount', count);
        });
      },
      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: any): Promise<void> => {
        await this.resource.update(data.id as number, data);
        data.scheduleContainer = { id: data.scheduleContainerId };
        delete data.scheduleContainerId;
        delete data.presentPlayersIds;
        context.commit('setEntity', data);
      }
    };
    this.mutations = {
      ...this.mutations,
      /**
       * Ustawia rodzaj encji
       *
       * @param {*} localState
       * @param {TableName} entityType
       */
      setEntityType(localState: any, entityType: TableName): void {
        localState.entityType = entityType;
      }
    };
  }
}

export default new FeePresencesModule();
